// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"835b8574","453":"af205ec6","583":"fd845f02"}[chunkId] + ".chunk.js";
};